import styled from 'styled-components'
import { Flex, Text } from '@pancakeswap/uikit'
import { useSpring, animated } from 'react-spring'
import { BsArrowRight } from '@react-icons/all-files/bs/BsArrowRight'
import { BsArrowBarLeft } from '@react-icons/all-files/bs/BsArrowBarLeft'
import { BsArrow90DegLeft } from '@react-icons/all-files/bs/BsArrow90DegLeft'

interface TextProps {
  fontSize?: string
  color?: string
}

export const SwiperFlex = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  flex: 4;
  padding: 8px;
  backdrop-filter: blur(4px);
  justify-content: space-evenly;
  @media (min-width: 1000px) {
    backdrop-filter: blur(24px);
    width: 100%;
  }
`
export const SwiperText = styled(Text)`
  font-size: 48px; 
  font-weight: 500; 
  color: ${({ theme, color }) => color || theme.colors.purple};

  }
`
export const SwiperSubText = styled(Text)<TextProps>`
  font-size: 36px; 
  font-weight: 600; 

  color: ${({ theme, color }) => color || theme.colors.secondary};

  }
`

export const ArrowFlex = styled(Flex)`
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 8px;
  flex: 2;
`

export const BouncingArrow = () => {
  const bouncing = useSpring({
    from: { transform: 'translateX(0px)' },
    to: { transform: 'translateX(-20px)' },
    loop: true,
    config: { duration: 5000 },
  })

  return (
    <animated.div style={bouncing}>
      <BsArrowRight />
    </animated.div>
  )
}

export const BouncingArrowLeft = () => {
  const bouncing = useSpring({
    from: { transform: 'translateX(0px)' },
    to: { transform: 'translateX(-20px)' },
    loop: true,
    config: { duration: 5000 },
  })

  return (
    <animated.div style={bouncing}>
      <BsArrow90DegLeft />
    </animated.div>
  )
}
